export class BookingSessionClassesOfService {
    constructor(private readonly allClasses: string[]) {
    }

    pso(availablePsoClasses: string[]): string[] {
        return availablePsoClasses.filter(c => this.allClasses.includes(c));
    }

    regular(availablePsoClasses: string[]): string[] {

        if(availablePsoClasses.length === 0) {
            return this.allClasses;
        }

        return this.allClasses.filter(c => !availablePsoClasses.includes(c));
    }

}